import React, { useContext, useEffect } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import { FeaturesEnum } from '../../../utils/features'
import CustomPlanCTA from '../../components/CustomPlan'
import { BaseLayout } from '../../layouts'
import {
  FileDetailBaseLayout,
  MediaLibraryBaseLayout,
} from '../../layouts/MediaLibrary'
import { UserContext } from '../../providers'
import { CustomMetadataProvider } from '../../providers/CustomMetadataProvider'
import { MediaCollectionsPage } from '.'
import { PublicLinksInfoContext } from '../../providers/PublicLinksInfoProvider'

const MediaCollectionRouter = (): React.ReactElement => {
  const { isPublicLink } = useContext(PublicLinksInfoContext)
  const { path } = useRouteMatch()
  const { user } = useContext(UserContext)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null

    function waitForIntercom(): void {
      if (window.Intercom?.booted) {
        try {
          window.Intercom('hide')
          window.Intercom('update', {
            hide_default_launcher: true,
          })
        } catch (e) {
          //do nothing
        }
        return
      }
      timeoutId = setTimeout(waitForIntercom, 100)
    }

    waitForIntercom()

    return () => {
      try {
        window.Intercom('update', {
          hide_default_launcher: false,
        })
      } catch (e) {
        //do nothing
      }
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [])


  return (
    <CustomMetadataProvider>
      <Switch>
        <Route path={`${path}/:mediaCollectionId/detail/:fileId`} exact>
          <MediaLibraryBaseLayout>
            <FileDetailBaseLayout />
          </MediaLibraryBaseLayout>
        </Route>

        <Route
          path={`${path}/:mediaCollectionId/detail/:fileId/:versionId`}
          exact
        >
          <MediaLibraryBaseLayout>
            <FileDetailBaseLayout />
          </MediaLibraryBaseLayout>
        </Route>

        <Route
          path={`${path}/:mediaCollectionId/:folderPathBase64?`}
          exact
          render={() =>
            isPublicLink ||
            user?.pricingPlan.featuresList.includes(
              FeaturesEnum.ACL_AND_COLLECTIONS,
            ) ? (
              <MediaLibraryBaseLayout>
                <MediaCollectionsPage />
              </MediaLibraryBaseLayout>
            ) : (
              <BaseLayout>
                <CustomPlanCTA feature={FeaturesEnum.ACL_AND_COLLECTIONS} />
              </BaseLayout>
            )
          }
        />

        <Route
          path={`${path}/:mediaCollectionId?`}
          exact
          render={() => {
            return (
              isPublicLink ||
              user?.pricingPlan.featuresList.includes(
                FeaturesEnum.ACL_AND_COLLECTIONS,
              ) ? (
                <MediaLibraryBaseLayout>
                  <MediaCollectionsPage />
                </MediaLibraryBaseLayout>
              ) : (
                <BaseLayout>
                  <CustomPlanCTA feature={FeaturesEnum.ACL_AND_COLLECTIONS} />
                </BaseLayout>
              )
            )
          }}
        />
      </Switch>
    </CustomMetadataProvider>
  )
}

export default MediaCollectionRouter
